import React from 'react'
import has from 'lodash/has'
import upperFirst from 'lodash/upperFirst'
import isArray from 'lodash/isArray'
import NotFound from './NotFound'
import Banners from './Misc/Banners'
import Markup from './Misc/Markup'
import ExchangeRate from './Misc/ExchangeRate'
import SectionPage from './Misc/SectionPage'
import ShippingPreset from './Misc/ShippingPreset'
import AttractionPromo from './Misc/AttractionPromo'
import FailedTransaction from './Misc/FailedTransaction'
import PromoSectionPage from './Misc/PromoSectionPage'
import Scheduler from './Misc/Scheduler'

const subList = {
  Banners: <Banners />,
  Markup: <Markup />,
  ExchangeRate: <ExchangeRate />,
  SectionPage: <SectionPage />,
  ShippingPreset: <ShippingPreset />,
  AttractionPromo: <AttractionPromo />,
  FailedTransaction: <FailedTransaction />,
  PromoSection: <PromoSectionPage />,
  Scheduler: <Scheduler />
}

const SubComponent = ({ subname = 'list' }) => {
  let index = subname
  index = index.split('-')
  if (!isArray(index)) {
    index = upperFirst(index)
  } else {
    index = index.map((el) => upperFirst(el))
    index = index.join('')
  }

  if (has(subList, index)) {
    return subList[index]
  } else {
    return <NotFound />
  }
}

const MiscPage = ({ location, match }) => <SubComponent subname={match.params.sub} location={location} />

export default MiscPage



// WEBPACK FOOTER //
// ./src/Pages/MiscPage.js